import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("VULNSUMMARYTABLE");

 const resetData = actionCreator<{data:userdata[]}>("VULNSUMMARYTABLE_ERESETDATA");

 export const TableThingyActions = { resetData}


